











































import {Component, Prop, Vue} from 'vue-property-decorator';
import {FAVORITE_PREFIX, ItemFavoriteStore, SessionStore} from '../../store';
import {FormValidationService} from '../../services';
import type {QForm} from 'quasar';


@Component
export default class FavoriteAdd extends Vue {
	@Prop({type: Boolean, default: false})
	loading!: false;

	@Prop({default: null})
	saveButtonLabel!: string | null;

	@Prop({default: () => null})
	saveFavoriteCallback!: (name: string) => void | Promise<void>;

	@Prop({default: null})
	sharedFavoriteId!: string | null;

	customName = '';

	rulesFavName = [
		FormValidationService.ruleRequired,
		FormValidationService.ruleFavoriteNameIsValid,
		FormValidationService.ruleFavoriteNameIsUnique,
	];

	get brandName(): string {
		return SessionStore.brandConfig?.brandName || '';
	}

	get favoriteName(): string {
		return this.customName || 'XYZ';
	}

	get favoritePrefix(): string {
		return FAVORITE_PREFIX;
	}

	get useSaveButtonLabel(): string {
		return this.saveButtonLabel ?? 'Save name';
	}

	created() {
		// If we are favoriting something shared, start with its name
		if(this.sharedFavoriteId) {
			const sharedFavorite = ItemFavoriteStore.sharedFavorite(this.sharedFavoriteId);
			if(sharedFavorite) {
				this.customName = sharedFavorite.name;
			}
		}
	}


	saveFavorite() {
		if(typeof this.saveFavoriteCallback === 'function') {
			this.saveFavoriteCallback(this.customName.trim());
		}
	}

	submitForm() {
		// QForm won't submit unless valid
		(this.$refs.formFavName as QForm).submit();
	}

	updateName(value: string) {
		this.customName = FormValidationService.convertSmartSingleQuotesToStraight(value);
	}
}
